<template>
    <div class="w-100">
        <div class="match-table" v-show="!isShowNoDataTable">
            <Sticky
                :top="89"
                :show="89"
                :ignore="!isMobile"
                Class="scroll_top_nav2"
                stickyClass="scroll_top_nav2"
                :stickyShowBefore="true"
            >
                <div class="match-table__header has-border">
                    <div v-if="!isMobile" class="standing-title">
                        {{ $t("STANDINGS") }}
                    </div>
                    <div class="nav-pill__wrapper">
                        <div
                            class="nav-pill btn-aspn-default"
                            :class="{ selected: o.selected }"
                            v-for="(o, index) in tableTabs"
                            :key="index"
                            @click="selectTableTabs(o)"
                        >
                            {{ $t(o.name) }}
                        </div>
                    </div>

                    <div
                        v-if="!isMobile && rankingTable.list[0]"
                        class="standing-title standing-league-title py-16px"
                    >
                        <leagueIcon
                            :icon="
                                rankingTable.list[0].leagueName
                                    .replaceAll(' ', '-')
                                    .toLowerCase() +
                                `-${rankingTable.list[0].leagueId}`
                            "
                            className="mr-05rem icon-league league-standing-match__icon"
                        >
                            <img
                                :src="`${s3ImgUrl}/${rankingTable.list[0].logo}`"
                                class="league-standing-match__icon"
                            />
                        </leagueIcon>
                        {{ rankingTable.list[0].leagueName }}
                    </div>
                </div>
            </Sticky>
            <div class="standing-box" v-show="isShowLoading">
                <LoadingAspn type="standings"></LoadingAspn>
            </div>
            <div v-show="!isShowLoading">
                <div v-show="currentTableTabs === 'total'">
                    <MatchTable
                        :isShowTabs="false"
                        :type="'total'"
                        :rankingTable="rankingTable"
                        :matchTableListData="matchTableList"
                    ></MatchTable>
                </div>
                <div v-show="currentTableTabs === 'home'">
                    <MatchTable
                        :isShowTabs="false"
                        :type="'home'"
                        :rankingTable="rankingTable"
                        :matchTableListData="matchTableList"
                    ></MatchTable>
                </div>
                <div v-show="currentTableTabs === 'away'">
                    <MatchTable
                        :isShowTabs="false"
                        :type="'away'"
                        :rankingTable="rankingTable"
                        :matchTableListData="matchTableList"
                    ></MatchTable>
                </div>
                <div v-show="currentTableTabs === 'form'">
                    <MatchTable
                        :isShowTabs="false"
                        :type="'form'"
                        :rankingTable="rankingTable"
                        :matchTableListData="matchTableList"
                    ></MatchTable>
                </div>
            </div>
        </div>

        <div v-if="isShowNoDataTable && isMobile" class="pa-05rem">
            <NoData />
        </div>
    </div>
</template>

<script>
import MatchTable from "@/components/match/football/TableTeam.vue";
import { mapGetters, mapActions } from "vuex";
import config from "@/js/config.js";
import leagueIcon from "@/components/Icon/LeagueIcon.vue";

export default {
    inject: ["getStandingHistory"],
    data() {
        return {
            s3ImgUrl: config.s3ImgUrl,
            isShowNoDataTable: false,
            tableTabs: [
                {
                    name: "ALL",
                    id: "total",
                    selected: true,
                },
                {
                    name: "HOME",
                    id: "home",
                    selected: false,
                },
                {
                    name: "AWAY",
                    id: "away",
                    selected: false,
                },
                {
                    name: "FORM",
                    id: "form",
                    selected: false,
                },
            ],
            currentTableTabs: "total", //default show first 1
            rankingTable: {
                isShow: false,
                isShowArrow: true,
                isLoading: false,
                currentSelectedLeagueIndex: 0,
                list: [],
                currentSelectedLeague: "",
                leagueName: "",
                logo: "",
            },
            isShowLoading: true,
            matchTableList: [],
        };
    },
    components: {
        MatchTable,
        leagueIcon,
    },
    computed: {
        ...mapGetters(["teamInfo", "isMobile"]),
    },
    mounted() {
        this.init();
    },
    watch: {
        "getStandingHistory.boolean"(newVal, oldVal) {
            if (newVal === true) {
                if (this.getStandingHistory.season !== "") {
                    this.getPastSoccerLeagueRankingData(
                        this.getStandingHistory.season
                    );
                } else {
                    this.getSoccerLeagueRankingData();
                }
            }
        },
    },
    methods: {
        ...mapActions(["getSoccerLeagueRanking", "getPastSoccerLeagueRanking"]),
        init() {
            let interval = setInterval(() => {
                if (this.teamInfo.leagueId) {
                    clearInterval(interval);
                    this.getSoccerLeagueRankingData();
                }
            }, 1000);
        },
        selectTableTabs(o) {
            this.tableTabs.forEach((x) => {
                x.selected = false;
            });
            o.selected = true;

            this.currentTableTabs = o.id;
        },
        async getSoccerLeagueRankingData() {
            this.isShowLoading = true;

            let params = {
                leagueIdList: this.teamInfo.leagueId,
            };

            const result = await this.getSoccerLeagueRanking(params);
            this.isShowLoading = false;

            if (result.result.length === 0) {
                this.isShowNoDataTable = true;
            } else {
                this.isShowNoDataTable = false;
                this.rankingTable.list = result.result;
                this.generateStandingsFormList(this.rankingTable.list);
                this.handleLeagueListRankingTable();
            }
        },
        generateStandingsFormList(list) {
            list[0]["form"] = JSON.parse(JSON.stringify(list[0].total));
            list[0].form.forEach((x) => {
                x.promotionColor = null;
            });
        },
        async getPastSoccerLeagueRankingData(season) {
            this.isShowLoading = true;

            let params = {
                leagueIdList: this.teamInfo.leagueId,
                season: season,
            };

            const result = await this.getPastSoccerLeagueRanking(params);

            if (result.result.length === 0) {
                this.isShowNoDataTable = true;
            } else {
                this.isShowNoDataTable = false;
                this.rankingTable.list = result.result;
                this.handleLeagueListRankingTable();
            }
        },
        //ranking table
        handleLeagueListRankingTable(action) {
            let limit = this.rankingTable.list.length - 1;
            let index = 0;

            if (limit === 0) {
                this.rankingTable.isShowArrow = false;
            } else {
                this.rankingTable.isShowArrow = true;
            }

            if (action === "next") {
                if (this.rankingTable.currentSelectedLeagueIndex < limit) {
                    this.rankingTable.currentSelectedLeagueIndex++;
                } else {
                    this.rankingTable.currentSelectedLeagueIndex = 0;
                }
                index = this.rankingTable.currentSelectedLeagueIndex;
            } else if (action === "prev") {
                if (this.rankingTable.currentSelectedLeagueIndex > 0) {
                    this.rankingTable.currentSelectedLeagueIndex--;
                } else {
                    this.rankingTable.currentSelectedLeagueIndex = limit;
                }

                index = this.rankingTable.currentSelectedLeagueIndex;
            } else {
                index = 0;
            }

            this.rankingTable.currentSelectedLeague =
                this.rankingTable.list[index].tableName;
            this.matchTableList = this.rankingTable.list[index];
        },
    },
};
</script>

<style scoped>
.match-table {
    background: var(--color-background-default-secondary);
    border-radius: 16px;
    padding: 16px;
    box-sizing: border-box;
    width: 568px;
    letter-spacing: 0.56px;
}
.match-table__header .nav-pill__wrapper {
    margin-top: 16px;
    padding: 8px;
    padding-bottom: 16px;
    box-sizing: border-box;
    margin-right: 0 !important;
    /* border-bottom: 1px solid var(--color-border-default-default); */
}
.match-table__header .nav-pill__wrapper .nav-pill {
    border: 1px solid var(--color-border-default-default);
    border-radius: var(--size-radius-600);
    padding: 8px 24px;
    color: var(--color-text-default-default);
}
.match-table__header .nav-pill__wrapper .nav-pill:last-child {
    margin-right: 0;
}
.match-table__header .nav-pill__wrapper .nav-pill.selected {
    border: 1px solid var(--bg-selected) !important;
}
.standing-title {
    font-family: var(--weight-600);
    letter-spacing: 0.64px;
    color: var(--color-text-default-default);
}
.standing-league-title {
    padding: 0px 0 16px;
    font-size: 16px;
    font-family: var(--weight-600);
    display: flex;
    align-items: center;
}
@media(max-width: 768px) {
    /* for test */
    .match-table__header .nav-pill__wrapper .nav-pill {
        width: 100%;
        padding: 8px 16px;
        font-size: 14px;
        letter-spacing: 0.64px;
    }
    .match-table__header .nav-pill__wrapper .nav-pill:last-child {
        margin-right: 0;
    }
    .match-table {
        background: transparent;
        padding: 0 0 16px;
        width: 100%;
    }
    .match-table__header .nav-pill__wrapper {
        margin-top: 0;
        margin: 0;
        padding: 8px;
        box-sizing: border-box;
        margin-right: 0 !important;
        background: var(--color-background-default-secondary);
        /* margin-bottom: 8px; */
    }
    .scroll_top_nav {
        top: 93px;
        border-bottom: 1px solid var(--color-border-default-default);
        width: 100%;
        background: var(--color-background-default-secondary);
        left: 0;
    }
    .scroll_top_nav2 {
        border-bottom: 1px solid var(--color-border-default-default);
    }
    .has-border {
        border-bottom: 1px solid var(--color-border-default-default) !important;
    }
}
</style>

<style>
.league-standing-match__icon {
    width: 32px;
    height: 32px;
    margin-right: 8px;
}
</style>
